export const PLATFORM_TYPE = Object.freeze({
  WEB: 'web',
  BROWZWEAR: 'browzwear'
})

export const ACTIVE_BRAND_SESSION_KEY = 'stitch:dh:active-brand'
